import React, { useState, useEffect } from "react";
import { useStyles } from "./styles";
import { get } from "lodash";
import { useMutation } from "@apollo/client";
import { StyledBadge } from "../StyledBadge";
import MailOutlineOutlinedIcon from "@material-ui/icons/MailOutlineOutlined";
import {
  Box,
  Button,
  IconButton,
  List,
  Popover,
  Tooltip,
  Typography,
} from "@material-ui/core";
import CommunicationNotificationListItem from "./CommunicationNotificationListItem";
import { useTranslation } from "react-i18next";
import { loggedInUserDetails } from "../../../recoil/LoggedInUserDetail/selector";
import { useRecoilValue } from "recoil";
import {
  clearNotifications,
  readNotifications,
} from "../../../graphQL/mutation/communicationMutation";
import { checkArrayLength, getUserId } from "../../../utils";
import { Scrollbars } from "react-custom-scrollbars";
import { useMainTheme } from "../../../hooks/useMainTheme";
import EmptyStateIcon from "Assets/images/empty-state/msg-notif.svg";
import InfiniteScroll from "react-infinite-scroller";
// import LoadingWidget from "Components/widgets/LoadingWidget";
import NotificationSkeleton from "Components/SkeletonLoader/NotificationSkeleton";

const CommunicationNotification = ({
  notificationDetailSorted,
  setNotificationDetailSorted,
  nextToken,
  nextLazyLoad,
  refetchUserData,
  isReadNotification,
  unReadCount,
  isMobile,
  updatedCount,
  setUnReadCount,
  loading,
}) => {
  const styleProps = useMainTheme();
  const classes = useStyles(styleProps);
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  let _loggedInUserDetails = useRecoilValue(loggedInUserDetails);
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
  const userId = getUserId();
  const [clearAllNotifications] = useMutation(clearNotifications);
  const [readAllNotifications] = useMutation(readNotifications);
  const [isReadAll, setReadAll] = useState();
  const [hasMoreItem, setHasMoreItem] = useState(true);
  useEffect(() => {
    setHasMoreItem(nextToken ? true : false);
  }, [nextToken]);
  const getUnreadNotificationCount = () => {
    if (notificationDetailSorted.length) {
      let data = notificationDetailSorted.filter(
        (item) =>
          get(item, "isCommunicationNotification", true) &&
          get(item, "Isread", false) === false
      );
      if (data) {
        setUnreadNotificationCount(data.length);
      }
    } else {
      setUnreadNotificationCount(0);
    }
  };

  useEffect(() => {
    if (userId) {
      getUnreadNotificationCount();
    }
  }, [checkArrayLength(notificationDetailSorted), updatedCount]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const clearNotificationList = () => {
    handleClose();
    clearAllNotifications({
      variables: {
        companyId: get(_loggedInUserDetails, "companyId", ""),
        userId: get(_loggedInUserDetails, "id", ""),
        category: "Communication",
        isClearAll: true,
      },
    })
      .then(() => {
        setUnReadCount((res) => ({ ...res, ["Communication"]: 0 }));
        setNotificationDetailSorted([]);
        setUnreadNotificationCount(0);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const readAllNotificationHandler = () => {
    readAllNotifications({
      variables: {
        companyId: get(_loggedInUserDetails, "companyId", ""),
        userId: get(_loggedInUserDetails, "id", ""),
        category: "Communication",
        isreadAll: false,
      },
    })
      .then(() => {
        setUnReadCount((res) => ({ ...res, ["Communication"]: 0 }));
        setNotificationDetailSorted(
          notificationDetailSorted.map((n) => ({ ...n, Isread: true }))
        );
        setUnreadNotificationCount(0);
        setReadAll(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const displayNotificationList = () =>
    (notificationDetailSorted || []).map((notification, i) => {
      return (
        <CommunicationNotificationListItem
          key={i}
          isReadNotification={() =>
            isReadNotification(
              notification.id,
              setNotificationDetailSorted,
              notificationDetailSorted,
              "Communication"
            )
          }
          getUserData={() =>
            refetchUserData(
              notification.id,
              setNotificationDetailSorted,
              notificationDetailSorted
            )
          }
          handleClose={handleClose}
          notification={notification}
          setNotificationDetailSorted={setNotificationDetailSorted}
        />
      );
    });

  return (
    <>
      <IconButton
        data-testid="iconbtn"
        aria-label="show 4 new mails"
        color="inherit"
        className={classes.headerBtn}
        aria-describedby={id}
        onClick={handleClick}
      >
        <StyledBadge badgeContent={unReadCount} color="secondary">
          <Tooltip title="Messages">
            <MailOutlineOutlinedIcon />
          </Tooltip>
        </StyledBadge>
        {isMobile ? (
          <p className={classes.mobileMenuName}>{t("layout.messages")}</p>
        ) : null}
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        data-testid="handleClose"
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        className={classes.notifPopover}
      >
        <Box
          mb={0.5}
          className={classes.notifTitle}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="subtitle2" className="font-bold">
            {t("dashboard.communications")}
          </Typography>
          <Box display="flex" alignItems="center">
            <Button
              color="primary"
              className={`${
                checkArrayLength(notificationDetailSorted)
                  ? classes.clearBtn
                  : classes.disableBtn
              } font-13`}
              data-testid="readAllNotificationHandler"
              onClick={() => readAllNotificationHandler()}
            >
              Read all
            </Button>
            {checkArrayLength(notificationDetailSorted) ? (
              <>
                <span className={classes.vertDivider}>|</span>
                <Button
                  color="primary"
                  className={`${classes.clearBtn} font-12`}
                  data-testid="clearNotificationList"
                  onClick={() => clearNotificationList()}
                >
                  {t("dashboard.clearAll")}
                </Button>
              </>
            ) : null}
          </Box>
        </Box>
        {checkArrayLength(notificationDetailSorted) ? (
          <Box height="70vh" pb={0.5}>
            <Scrollbars
              renderTrackHorizontal={(props) => (
                <div {...props} style={{ display: "none" }} />
              )}
            >
              <InfiniteScroll
                data-testid="load"
                pageStart={0} // The page number from which to start fetching data
                loadMore={() => nextLazyLoad()} // The function to load more items
                hasMore={hasMoreItem}
                loader={<NotificationSkeleton />}
                useWindow={false}
                // dataLength={notificationDetailSorted?.length}
              >
                <List className={classes.popoverList}>
                  {displayNotificationList()}
                  {loading ? <NotificationSkeleton /> : null}
                </List>
              </InfiniteScroll>
            </Scrollbars>
          </Box>
        ) : (
          <Box pt={6} pb={6} textAlign="center">
            <img src={EmptyStateIcon} alt="no new notifications" />
            <Box mt={1} mb={2}>
              <Typography variant="body2" className="font-12">
                No new notifications
              </Typography>
            </Box>
          </Box>
        )}
      </Popover>
    </>
  );
};
export default CommunicationNotification;
